import { render, staticRenderFns } from "./title.md?vue&type=template&id=48425f8a&"
import script from "./title.md?vue&type=script&lang=js&"
export * from "./title.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48425f8a')) {
      api.createRecord('48425f8a', component.options)
    } else {
      api.reload('48425f8a', component.options)
    }
    module.hot.accept("./title.md?vue&type=template&id=48425f8a&", function () {
      api.rerender('48425f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/tooltip/title.md"
export default component.exports